<div class="card shadow-sm">
    <div class="card-header">
        <h4 class="mb-0">Rule Engine</h4>
    </div>

    <div class="card-body">
        <div class="row mb-3">
            <div class="col-xl-6 d-flex align-items-center">
                <label for="merchantDropdown" class="form-label me-2">Merchant</label>
                <ng-select id="merchantDropdown" placeholder="Select a merchant" [clearable]="false" class="flex-grow-0"
                    style="width: 200px;" (ngModelChange)="onMerchantSelect($event)" [(ngModel)]="selectedMerchant">
                    <ng-option value="ALL">Select Merchant</ng-option>
                    <ng-option *ngFor="let item of merchants" [value]="item.payId">
                        {{ item.businessName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>

        <!-- ON US Dropdown -->
        <div class="dropdown mb-4">
            <button class="btn dropdown-toggle w-100" type="button" id="onUsDropdown" (click)="toggleTab('first')">
                ON US
            </button>
        </div>

        <div *ngIf="activeTab === 'first'">
            <div *ngIf="selectedMerchant" class="table-responsive">
                <ng-container *ngIf="routerRules.length > 0; else noDataTemplate">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Merchant</th>
                                <th>Currency</th>
                                <th>Payment Type</th>
                                <th>Mop</th>
                                <th>Transaction Type</th>
                                <th>Acquirer</th>
                                <th>Region</th>
                                <th>Type</th>
                                <th>Actions</th>
                            </tr>
                            <tr>
                                <th>
                                    <input type="checkbox" (change)="toggleSelectAll($event)" />
                                    <span> Select All</span>
                                </th>
                                <td colspan="9" style="text-align: right;">
                                    <button class="btn btn-danger" (click)="deleteSelected()"
                                        style="margin-right: 50px;">Delete ALL</button>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let rule of routerRules">
                                <td>
                                    <input type="checkbox" [(ngModel)]="rule.selected" />
                                </td>
                                <td>{{ rule.merchant }}</td>
                                <td>{{ rule.currency }}</td>
                                <td>{{ rule.paymentType }}</td>
                                <td>{{ rule.mopType }}</td>
                                <td>{{ rule.transactionType }}</td>
                                <td>
                                    <ng-container *ngIf="!isEditing || selectedRule?.id !== rule.id; else editTemplate">
                                        {{ getFormattedAcquirerMap(rule.acquirerMap) }}
                                    </ng-container>

                                    <ng-template #editTemplate>
                                        <div>{{ getFormattedAcquirerMap(rule.acquirerMap) }}</div>
                                        <div style="border: 1px solid #000;padding: 5px;margin-bottom: 3px;"
                                            *ngFor="let acquirer of selectedRules.acquirers; let i = index">
                                            <label>Acquirer {{ i + 1 }}:</label>
                                            <div *ngFor="let option of getRemainingAcquirers(i)">
                                                <input type="radio" name="acquirer{{ i }}" [value]="option"
                                                    [(ngModel)]="selectedRules.acquirers[i]" />
                                                {{ option }}
                                            </div>
                                            <button *ngIf="i>0" (click)="removeAcquirer(i)">Remove</button>
                                        </div>
                                        <button (click)="addAcquirer()">Add Acquirer</button>
                                    </ng-template>

                                </td>
                                <td>{{ rule.paymentsRegion }}</td>
                                <td>{{ rule.cardHolderType }}</td>
                                <td>
                                    <ng-container
                                        *ngIf="!isEditing || selectedRule?.id !== rule.id; else updateTemplate">
                                        <button class="btn btn-primary" (click)="onEdit(rule)"
                                            [disabled]="!rule.selected">Edit</button>
                                        <button class="btn btn-danger" (click)="onRemove(rule)"
                                            [disabled]="!rule.selected">Remove</button>
                                    </ng-container>
                                    <ng-template #updateTemplate>
                                        <button class="btn btn-success" (click)="onUpdate()">Update</button>
                                        <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
                                    </ng-template>
                                </td>
                            </tr>
                        </tbody>



                    </table>
                </ng-container>
                <ng-template #noDataTemplate>
                    <div class="alert alert-warning" role="alert">
                        No Rules available.
                    </div>
                </ng-template>
            </div>




            <!-- <div class="row mb-3">
                <div class="col-xl-12 d-flex align-items-center">
                    <label for="firstDropdown" class="form-label me-2">Create Rule</label>
                    <ng-select
                        id="firstDropdown"
                        [(ngModel)]="selectedMerchantbydefault"
                        [clearable]="false"
                        class="flex-grow-0"  
                        style="width: 200px;">
                       <ng-option *ngFor="let item of merchants" [value]="item.payId">
                        {{item.businessName}}
                       </ng-option>      
                    </ng-select>
                </div>
            </div>

            <div class="container">
                <div class="row mb-2 d-flex align-items-start">
                    <div class="col-md-1 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Currency</label>
                        <div class="d-flex flex-column">
                          <label><input type="checkbox" name="currency" value="AED" [(ngModel)]="selectedCurrencies['AED']"> AED</label>
                          <label><input type="checkbox" name="currency" value="CAD" [(ngModel)]="selectedCurrencies['CAD']"> CAD</label>
                          <label><input type="checkbox" name="currency" value="AUD" [(ngModel)]="selectedCurrencies['AUD']"> AUD</label>
                          <label><input type="checkbox" name="currency" value="INR" [(ngModel)]="selectedCurrencies['INR']"> INR</label>
                          <label><input type="checkbox" name="currency" value="USD" [(ngModel)]="selectedCurrencies['USD']"> USD</label>
                          <label><input type="checkbox" name="currency" value="EUR" [(ngModel)]="selectedCurrencies['EUR']"> EUR</label>
                          <label><input type="checkbox" name="currency" value="GBP" [(ngModel)]="selectedCurrencies['GBP']"> GBP</label>
                        </div>
                      </div>
                      
            
                    <div class="col-md-1 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Acquirer</label>
                        <div class="d-flex flex-column">
                            <label><input type="radio" name="acquirer2" value="Acquirer1" [(ngModel)]="selectedAcquirer2"> Acquirer 1</label>
                        </div>
                    </div>
            
                    <div class="col-md-2 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Payment Type</label>
                        <div class="d-flex flex-column">
                            <label><input type="radio" name="paymentType2" value="Type1" [(ngModel)]="selectedPaymentType2"> Type 1</label>
                        </div>
                    </div>
            
                    <div class="col-md-1 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Mop</label>
                        <div class="d-flex flex-column">
                          <label><input type="checkbox" name="mopType" value="Type1" [(ngModel)]="selectedMopTypes['Type1']"> Type 1</label>
                          <label><input type="checkbox" name="mopType" value="Type2" [(ngModel)]="selectedMopTypes['Type2']"> Type 2</label>
                        </div>
                      </div>
                      
                      <div class="col-md-2 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Transaction Type</label>
                        <div class="d-flex flex-column">
                          <label><input type="checkbox" name="transactionType" value="AUTHORISE" [(ngModel)]="selectedTransactionTypes['AUTHORISE']"> AUTHORISE</label>
                          <label><input type="checkbox" name="transactionType" value="SALE" [(ngModel)]="selectedTransactionTypes['SALE']"> SALE</label>
                        </div>
                      </div>
                      
            
                    <div class="col-md-2 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Region</label>
                        <div class="d-flex flex-column">
                            <label><input type="radio" name="regionType" value="Type1" [(ngModel)]="selectedRegionType">International                            </label>
                            <label><input type="radio" name="regionType" value="Type2" [(ngModel)]="selectedRegionType"> Domestic</label>
                        </div>
                    </div>
            
                    <div class="col-md-2 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Type</label>
                        <div class="d-flex flex-column">
                            <label><input type="radio" name="type" value="Type1" [(ngModel)]="selectedType"> Consumer</label>
                            <label><input type="radio" name="type" value="Type2" [(ngModel)]="selectedType"> Commercial</label>
                        </div>
                    </div>
            
                    <div class="col-md-1 d-flex flex-column">
                        <label class="form-label fw-bold text-dark" >Action</label>
                        <div>
                            <button class="btn btn-primary me-2 mb-2" (click)="onSave()">Save</button>
                            <button class="btn btn-secondary" (click)="onReset()">Reset</button>
                        </div>
                    </div>
                    
                </div>
            </div> -->


        </div>

        <!-- OFF US Dropdown -->
        <div class="dropdown mb-4">
            <button class="btn dropdown-toggle w-100" type="button" id="offUsDropdown" (click)="toggleTab('second')">
                OFF US
            </button>
        </div>

        <div *ngIf="activeTab === 'second'">
            <div class="row mb-3">
                <div class="col-xl-12 d-flex align-items-center">
                    <label for="firstDropdown" class="form-label me-2">Create Rule</label>
                    <ng-select id="firstDropdown" [(ngModel)]="selectedMerchantbydefault"
                        (change)="handleMerchantSelection($event)" [clearable]="false" class="flex-grow-0"
                        style="width: 200px;">
                        <ng-option *ngFor="let item of merchants" [value]="item.payId">
                            {{ item.businessName }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="container">
                <div class="row mb-2 d-flex align-items-start">
                    <div class="col-md-1 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Currency</label>
                        <div class="d-flex flex-column">
                            <ng-container *ngFor="let currency of currencies">
                                <label>
                                    <input type="checkbox" name="currency" [value]="currency"
                                        (change)="handleCurrencySelection(currency, $event)">
                                    {{ currency }}

                                </label>
                            </ng-container>
                            <label *ngIf="currencies.length === 0">No currencies available</label>
                        </div>
                    </div>

                    <div class="col-md-1 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Acquirer</label>
                        <div class="d-flex flex-column" *ngIf="isAcquirer">
                            <ng-container *ngFor="let acquirer of acquirers">
                                <label>
                                    <input type="radio" name="acquirer2" [value]="acquirer"
                                        [(ngModel)]="selectedAcquirer2" (change)="handleAcquirerSelection(acquirer)">
                                    {{acquirer}}
                                </label>
                            </ng-container>
                            <label *ngIf="acquirers.length === 0">No acquirers</label>
                        </div>
                    </div>

                    <div class="col-md-2 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Payment Type</label>
                        <div class="d-flex flex-column" *ngIf="selectedAcquirer2">
                            <ng-container *ngFor="let paymentType of paymentTypes">
                                <label>
                                    <input type="radio" name="paymentType2" [value]="paymentType"
                                        [(ngModel)]="selectedPaymentType2"
                                        (change)="handlePaymentTypeSelection(paymentType)"> {{ paymentType }}
                                </label>
                            </ng-container>
                            <label *ngIf="!paymentTypes.length">No payment types</label>
                        </div>
                    </div>

                    <div class="col-md-1 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Mop Type</label>
                        <div class="d-flex flex-column" *ngIf="selectedPaymentType2">
                            <ng-container *ngFor="let mopType of mopTypes">
                                <label>
                                    <input type="checkbox" name="mopType" [value]="mopType"
                                        [(ngModel)]="selectedMopTypes[mopType]">
                                    {{ mopType }}
                                </label>
                            </ng-container>
                            <label *ngIf="!mopTypes.length">No mop</label>
                        </div>
                    </div>



                    <div class="col-md-2 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Transaction Type</label>
                        <div class="d-flex flex-column">
                            <label><input type="checkbox" name="transactionType" value="AUTHORISE"
                                    [(ngModel)]="selectedTransactionTypes['AUTHORISE']"> AUTHORISE</label>
                            <label><input type="checkbox" name="transactionType" value="SALE"
                                    [(ngModel)]="selectedTransactionTypes['SALE']"> SALE</label>
                        </div>
                    </div>


                    <div class="col-md-2 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Region</label>
                        <div class="d-flex flex-column">
                            <label><input type="radio" name="regionType" value="INTERNATIONAL"
                                    [(ngModel)]="selectedRegionType">International </label>
                            <label><input type="radio" name="regionType" value="DOMESTIC"
                                    [(ngModel)]="selectedRegionType">
                                Domestic</label>
                        </div>
                    </div>

                    <div class="col-md-2 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Type</label>
                        <div class="d-flex flex-column">
                            <label><input type="radio" name="type" value="CONSUMER" [(ngModel)]="selectedType">
                                Consumer</label>
                            <label><input type="radio" name="type" value="COMMERCIAL" [(ngModel)]="selectedType">
                                Commercial</label>
                        </div>
                    </div>

                    <div class="col-md-1 d-flex flex-column">
                        <label class="form-label fw-bold text-dark">Action</label>
                        <div>
                            <button class="btn btn-primary me-2 mb-2" (click)="onSave()">Save</button>
                            <button class="btn btn-secondary" (click)="offReset()">Reset</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>